module.exports = __webpack_public_path__ + "img/39_9.24ea0867.png";